var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.codeInputLabel)?_c('label',{staticClass:"form-label",attrs:{"for":_vm.rid}},[_vm._v(_vm._s(_vm.codeInputLabel)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }